import { Dispatch, SetStateAction, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

import { axios } from '#api/axios';

import { Modal } from '#molecules';
import { formatLeftDays } from 'src/refactor_shared/lib/parseTime';
import { DashboardChartModal } from '#pages/DashboardCustomer/DashboardChartModal';

type ExerciseChartsResponse = {
  taughtAt: string;
  person: {
    name: string;
  };
  id: string;
};

const ScheduleModal = ({
  setModalOpen
}: {
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const [innerModalRegisterId, setInnerModalRegisterId] = useState('');
  const { data } = useQuery({
    queryKey: ['get-coach-exercise-charts'],
    queryFn: async () =>
      await axios.get<Array<ExerciseChartsResponse>>(
        '/registered-lectures/schedule/list'
      ),
    select: ({ data }) => data
  });

  return (
    <>
      <Modal
        onClose={() => setModalOpen(false)}
        className="flex flex-col py-24 px-16"
      >
        <p className="text-[20px] text-[#BCB8C3] self-start">
          운동 차트 작성 수업 선택
        </p>
        <div className="w-full">
          <p className="text-[#948F9E] text-right">
            작성 필요{' '}
            <span className="font-bold text-[14px] text-[#BCB8C3]">
              {data ? data.length : 0}개
            </span>
          </p>

          <div className="w-full overflow-scroll h-300">
            {data &&
              data.map(value => {
                const { parseDate, daysDifference } = formatLeftDays(
                  value.taughtAt
                );
                return (
                  <div
                    className="py-20 w-full border-b-1 border-solid border-[#2E2B36] flex items-center justify-between"
                    key={value.id}
                  >
                    <p className="flex flex-col gap-8">
                      <span>{value.person.name} 회원님</span>

                      <span className="text-[14px]">
                        {parseDate}
                        <span> · </span>
                        <span
                          className={`${
                            daysDifference ? 'text-[#E13A3A]' : ''
                          }`}
                        >
                          {daysDifference
                            ? `${daysDifference}일 경과`
                            : '오늘 수업'}
                        </span>
                      </span>
                    </p>
                    <button
                      type="button"
                      onClick={() => setInnerModalRegisterId(value.id)}
                      className="px-16 py-11 rounded-8 bg-[#7750E9] text-[#EAE8ED] text-[14px]"
                    >
                      작성하기
                    </button>
                  </div>
                );
              })}
          </div>
        </div>

        <button
          className="text-center w-full px-20 py-16 rounded-8 bg-[#2E2B36] text-[#C9C7D1]"
          onClick={() => setModalOpen(false)}
        >
          확인
        </button>
      </Modal>
      {innerModalRegisterId && (
        <DashboardChartModal
          onClose={() => setInnerModalRegisterId('')}
          registeredLectureId={innerModalRegisterId}
        />
      )}
    </>
  );
};

export default ScheduleModal;
